module.exports = __webpack_public_path__ + "img/GN.7de80736.svg";